module.exports = __webpack_public_path__ + "img/banner_new.03703983.png";